<template>
  <container>
    <checkout-progress />

    <modal
      v-if="!approved || !ticketsAvailable"
      no-close
      center-content
    >
      <loader-spinner :size="1.5" />
      <template #footer>
        <span v-html="$t('loading')" />
      </template>
    </modal>

    <template v-if="$route.meta.type === 'confirmation'">
      <header
        v-if="approved && ticketsAvailable"
        class="cart__header"
      >
        <headline>{{ $t(orderData.giftcardorder ? 'confirmationGiftcards.title' : 'confirmation.title') }}</headline>
        <p>{{ $t(orderData.giftcardorder ? 'confirmationGiftcards.introduction' : 'confirmation.introduction') }}</p>
      </header>

      <cart-booking-download
        v-if="approved && ticketsAvailable"
        :order-data="orderData"
      />
    </template>
    <template v-else-if="$route.meta.type === 'wallet'">
      <header
        v-if="approved && ticketsAvailable"
        class="cart__header"
      >
        <headline>{{ $t('wallet.title') }}</headline>
        <p v-html="$t('wallet.introduction')" />
      </header>

      <cart-booking-wallet
        v-if="approved && ticketsAvailable"
        :order-data="orderData"
      />
    </template>
  </container>
</template>

<script>
import cartBookingDownload from '../components/cartBookingDownload.vue'
import cartBookingWallet from '../components/cartBookingWallet.vue'
import checkoutProgress from '../components/checkoutProgress.vue'
import container from '../components/container.vue'
import headline from '../components/headline.vue'
import loaderSpinner from '../components/loaderSpinner.vue'
import modal from '../components/modal.vue'

import api from '../api.js'
import eventBus from '../eventBus.js'

export default {
  name: 'VBookingConfirmation',

  polling: null,

  components: {
    cartBookingDownload,
    cartBookingWallet,
    checkoutProgress,
    container,
    headline,
    loaderSpinner,
    modal
  },

  data () {
    return {
      approved: false,
      ticketsAvailable: false,
      voucherLoaded: false,
      ticketsLoaded: true,
      orderData: {}
    }
  },

  mounted () {
    this.pollStatus()
    this.$tracking.track(this.$route.path, 'b-be')
  },

  created () {
    if (Object.keys(this.$store.state.vouchers).length === 0 && this.$store.state.vouchers.constructor === Object) {
      this.$store.dispatch('getVoucherTypes').then(response => {
        this.voucherLoaded = true
      })
    } else {
      this.voucherLoaded = true
    }
  },

  methods: {
    pollStatus: function () {
      api.get('checkout/' + this.$route.params.referenceid + '/status/').then(response => {
        if (response.data.status === 'approved') {
          this.polling = null
          this.approved = true
          this.processCheckout()
        } else if (response.data.status === 'invalid') {
          eventBus.emit('handleError')
        } else {
          this.polling = setTimeout(this.pollStatus, 2000)
        }
      }, error => { eventBus.emit('handleError', error.response.data.error) })
    },

    processCheckout: function () {
      api.post('checkout/' + this.$route.params.referenceid + '/process/').then(response => {
        this.orderData = response.data
        this.ticketsAvailable = true
        this.$tracking.eetConfirmCheckout(this.$route.params.referenceid, this.orderData)
      }, error => { eventBus.emit('handleError', error.response.data.error) })
    }
  }
}
</script>

<i18n locale="en">
{
  "confirmation": {
    "title": "Booking confirmed",
    "introduction": "Thank you for your order – we are looking forward to your visit to Miniatur Wunderland Hamburg! We have sent you your tickets as a PDF via email. If you want to you can already download your tickets here. Please present your tickets on your smartphone or as a printout on the day of your visit."
  },
  "confirmationGiftcards": {
    "title": "Purchase confirmed",
    "introduction": "Thank you for your gift card purchase - we hope you enjoy giving it away! Download the gift cards now and save them. You can give away the gift card as Print@Home or by email."
  },
  "wallet": {
    "title": "Save tickets on your smartphone",
    "introduction": "Simply click on the following tickets and follow the instructions of the app.<br>User of Android smartphones first need to install <a href=\"https://play.google.com/store/search?q=wallet\" target=\"_blank\" rel=\"noopener\">any Android compatible app</a>."
  },
  "loading": "Payment validation, please wait!<br>Sometimes this process can take several minutes."
}
</i18n>

<i18n locale="de">
{
  "confirmation": {
    "title": "Buchung bestätigt",
    "introduction": "Vielen Dank für Ihre Ticketbuchung – wir freuen uns auf Ihren Besuch im Miniatur Wunderland Hamburg! Ihre Tickets haben wir Ihnen als PDF per E-Mail zugeschickt. Sie können die Tickets aber auch gleich hier herunterladen. Bitte zeigen Sie diese Tickets bei Ihrem Besuch auf dem Handy vor oder drucken Sie diese aus."
  },
  "confirmationGiftcards": {
    "title": "Kauf bestätigt",
    "introduction": "Vielen Dank für Ihren Gutscheinkauf – wir wünschen Ihnen viel Freude beim Verschenken! Laden Sie sich die Gutscheine jetzt herunter und speichern sie. Die Gutscheine können Sie als Print@Home oder per E-Mail verschenken."
  },
  "wallet": {
    "title": "Tickets auf dem Smartphone speichern",
    "introduction": "Klicken Sie die folgenden Tickets an und folgen Sie der Anweisung der App.<br>Nutzer eines Android Smartphones benötigen hierfür eine <a href=\"https://play.google.com/store/search?q=wallet\" target=\"_blank\">mit Android kompatible App</a>."
  },
  "loading": "Zahlung wird geprüft, bitte warten!<br>Dieser Vorgang kann gelegentlich einige Minuten dauern."
}
</i18n>
